import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/24/outline';
import { bgColor, focusVisible } from '../../Resources/CSS/styling';
import { useTranslation } from '../../Translation';

const items = [
    { id: 1, title: 'Back End Developer', department: 'Engineering', type: 'Full-time', location: 'Remote' },
    { id: 2, title: 'Front End Developer', department: 'Engineering', type: 'Full-time', location: 'Remote' },
    { id: 3, title: 'User Interface Designer', department: 'Design', type: 'Full-time', location: 'Remote' },
]

export default function Pagination({ pagination }) {
    const { page_at, max_pages, page_size, total_records } = pagination.metaData || {};

    const minPage = Math.max(1, page_at - 2);
    const maxPage = Math.min(max_pages, page_at + 2);

    const pages = [];
    for (let i = minPage; i <= maxPage; i++) {
        pages.push(i);
    }

    const startRecord = (page_at - 1) * page_size + 1;
    const endRecord = Math.min(startRecord + page_size - 1, total_records);

    const { translate } = useTranslation();

    const setPage = (page) => {
        if (page > 0 && page <= max_pages) {
            pagination.setPage(page);
        }
    }

    return (
        <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
            <div className="flex flex-1 justify-between sm:hidden">
                <a
                    onClick={() => setPage(page_at - 1)}
                    className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    Previous
                </a>
                <a
                    onClick={() => setPage(page_at + 1)}
                    className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    Next
                </a>
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div>
                    <p className="text-sm text-gray-700">
                        {translate('pagination.showing')} <span className="font-medium">{startRecord}</span> {translate('pagination.to')} <span className="font-medium">{endRecord}</span> {translate('pagination.of')}
                        <span className="font-medium"> {total_records}</span> {translate('pagination.results')}
                    </p>
                </div>
                <div>
                    <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-sm">
                        <a
                            onClick={() => setPage(1)}
                            className="cursor-pointer relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        >
                            <span className="sr-only">Previous</span>
                            <ChevronDoubleLeftIcon aria-hidden="true" className="size-5" />
                        </a>
                        <a
                            onClick={() => setPage(page_at - 1)}
                            className="cursor-pointer relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        >
                            <span className="sr-only">Previous</span>
                            <ChevronLeftIcon aria-hidden="true" className="size-5" />
                        </a>
                        {pages.map((page) => (
                            <a
                                onClick={() => setPage(page)}
                                aria-current={page === page_at ? 'page' : undefined}
                                className={page === page_at ? `relative z-10 inline-flex items-center ${bgColor} px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${focusVisible} cursor-pointer` : 'relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 cursor-pointer'}
                            >
                                {page}
                            </a>
                        ))}
                        <a
                            onClick={() => setPage(page_at + 1)}
                            className="cursor-pointer relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        >
                            <span className="sr-only">Next</span>
                            <ChevronRightIcon aria-hidden="true" className="size-5" />
                        </a>
                        <a
                            onClick={() => setPage(max_pages)}
                            className="cursor-pointer relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        >
                            <span className="sr-only">Next</span>
                            <ChevronDoubleRightIcon aria-hidden="true" className="size-5" />
                        </a>
                    </nav>
                </div>
            </div>
        </div>
    )
}
